import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router } from '../devices.models';

@Component({
    selector: 'liebherr-connection-state',
    templateUrl: 'connection-state.component.html',
    styleUrls: ['connection-state.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConnectionStateComponent {
    @Input() device?: Router;

    constructor() {}
}
